/**
 * Surface styling shared by every nudge chrome (card, collapsed row, and the standard body).
 *
 * The hex values are NOT design-system tokens, and that is deliberate for now: they came from the
 * Figma spec via the `AiRecommendationFloatingCard` this replaced, and no semantic token maps to
 * them exactly (`#d9d9e0`, `#fcfdfe`, `#0a0a0a`, `#737373`). Swapping them for the nearest tokens
 * would move pixels, and phase 2 of this migration promised visual parity.
 *
 * Centralizing them here is the part worth doing now: the palette had been copied across three
 * components, so a future token migration is one edit in one file instead of a hunt.
 */
export const NUDGE_SURFACE = {
  /** Card and collapsed-row shell: border, background, radius. */
  shell: 'rounded-2xl border border-[#d9d9e0] border-solid bg-[#fcfdfe]',
  /** Elevation for the expanded card. */
  shadow: 'shadow-[0_4px_6px_-2px_rgba(0,0,0,0.05),0_10px_15px_-3px_rgba(0,0,0,0.1)]',
  /** Lighter elevation for a collapsed row, which sits behind the expanded card. */
  shadowCollapsed: 'shadow-[0_4px_6px_-2px_rgba(0,0,0,0.05)]',
  /** Inner padding of the expanded card. */
  padding: 'p-[14px]',
  /** Title / primary text. */
  title: 'text-[#0a0a0a]',
  /** Muted controls, such as the close button. */
  muted: 'text-[#737373]',
} as const;
